"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerTableConf = void 0;
var end2end_1 = require("@hudled/end2end");
var constants_1 = require("containers/TableMaker/constants");
var RemoveOrReinstateButton_1 = __importDefault(require("./CellComponents/RemoveOrReinstateButton"));
var LG = constants_1.CellSize.LG, MD = constants_1.CellSize.MD, SM = constants_1.CellSize.SM;
exports.customerTableConf = {
    headersMap: {
        'totalLTMSaasSpendInFx.AUD': 'Spend L12M (AUD)',
        'totalLTMSaasSpendInFx.USD': 'Spend L12M (USD)',
        'totalSaasSpendInFx.AUD': 'Total (AUD)',
        'totalSaasSpendInFx.USD': 'Total (USD)',
        serviceStatsCount: 'Tools',
        userCount: 'Users',
        createdAt: 'Joined',
        planDetails: 'Pricing Plan (MRR)',
    },
    extractors: {
        planDetails: function (company) { return "".concat(company.plan || '', " - ").concat(company.planFrequency || ''); },
        product: function (c) { return c.hasRecharglyAccess ? 'Rechargly' : 'Hudled'; },
    },
    cells: [
        {
            field: 'name', cell: { width: LG }, avatar: { size: 'xxs' }, truncate: {}, footerAggregate: 'count', countInHeader: true,
        },
        { field: 'product', cell: { width: LG, textAlign: 'center' }, hiddenOnPartial: true },
        {
            field: 'totalLTMSaasSpendInFx.AUD',
            cell: { width: LG },
            money: { currency: '', isRounded: true },
            footerAggregate: 'sum',
            hiddenOnPartial: true,
        },
        {
            field: 'totalLTMSaasSpendInFx.USD',
            cell: { width: LG },
            money: { currency: '', isRounded: true },
            footerAggregate: 'sum',
            hiddenOnPartial: true,
        },
        {
            field: 'totalSaasSpendInFx.AUD',
            cell: { width: LG },
            money: { currency: '', isRounded: true },
            footerAggregate: 'sum',
            hiddenOnPartial: true,
        },
        {
            field: 'totalSaasSpendInFx.USD',
            cell: { width: LG },
            money: { currency: '', isRounded: true },
            footerAggregate: 'sum',
            hiddenOnPartial: true,
        },
        {
            cell: { width: MD, textAlign: 'right' }, field: 'serviceStatsCount', footerAggregate: 'sum', hiddenOnPartial: true,
        },
        {
            cell: { width: MD, textAlign: 'right' }, field: 'userCount', footerAggregate: 'sum', hiddenOnPartial: true,
        },
        {
            cell: { width: LG, textAlign: 'right' }, field: 'employeeCount', footerAggregate: 'sum', hiddenOnPartial: true,
        },
        { cell: { width: LG, textAlign: 'left', offset: 'left' }, field: 'baseCurrency', hiddenOnPartial: true },
        {
            cell: { width: MD, textAlign: 'left' }, field: 'createdAt', renderField: end2end_1.getISODate, defaultOrder: -1, hiddenOnPartial: true,
        },
        {
            cell: { width: MD, textAlign: 'left' }, hiddenOnPartial: true, field: 'lastSync', renderField: end2end_1.getISODate,
        },
        { cell: { width: LG, textAlign: 'left' }, hiddenOnPartial: true, field: 'planDetails' },
        {
            cell: { width: SM, isActionCell: true }, key: 'setIsTest', hiddenOnPartial: true, renderComponent: RemoveOrReinstateButton_1.default,
        },
    ],
};
